import { InjectionToken } from '@angular/core';

import { Observable } from 'rxjs';

import { GetPaginationRes, Operation } from '@iw/core/entities';

import { GetOrdersReq } from '../models';
import { GetOrderRes } from '../models/get-order-res.model';
import { SendCommentReq } from '../models/send-comment-req.model';

export interface OrdersHistoryApi {
  cancelOrder(params: { id: string }): Observable<void>;
  sendComment(params: SendCommentReq): Observable<void>;
  getOrder(params: { id: string }): Observable<GetOrderRes>;
  getOrders(params: GetOrdersReq): Observable<GetPaginationRes<Operation>>;
}

export const ORDERS_HISTORY_API = new InjectionToken<OrdersHistoryApi>(
  'ORDERS_HISTORY_API',
);
